var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-btn',{class:[_vm.$style.btn, ( _obj = {}, _obj[_vm.$style.isFavorite] = _vm.isFavorite, _obj[_vm.$style.notFavorite] = !_vm.isFavorite, _obj )],attrs:{"icon":"star-rounded","theme":"primary","title":_vm.$t(("button." + (_vm.isFavorite ? 'removeFromFavorites' : 'addToFavorites')))},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle()}}})}
var staticRenderFns = []

export { render, staticRenderFns }